<template>
    <loading :active="isLoading"
             :is-full-page="fullPage"
             background-color="white"
             :opacity="1"
             :z-index="10000"></loading>
</template>

<script>
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Import component
import Loading from 'vue-loading-overlay';

export default {
    name: 'loader',

    data() {
        return {
            isLoading: true,
            fullPage: true
        }
    },
    components: {
        Loading
    },
    mounted() {
        window.addEventListener('load', () => {
            setTimeout(this.disable, 1000);
        })

    },
    methods: {
        disable: function () {
            this.isLoading = false;
        }
    }
}
</script>
